import { useSearchParams, useRouter } from 'next/navigation';
import { useMemo } from 'react';

const useCustomSearchParams = () => {
  const searchParams = useSearchParams();
  const router = useRouter();

  const params = useMemo(
    () => new URLSearchParams(searchParams.toString()),
    [searchParams]
  );

  const setParam = (name: string, value: string) => {
    params.set(name, value);
    const queryString = params.toString();
    router.push(`${window.location.pathname}?${queryString}`);
  };

  const deleteParam = (name: string) => {
    params.delete(name);
    const queryString = params.toString();
    router.push(`${window.location.pathname}?${queryString}`);
  };

  const getParam = (name: string): string | null => {
    return params.get(name);
  };

  const getAllParams = () => {
    const paramObj: { [key: string]: string } = {};
    params.forEach((value, key) => {
      paramObj[key] = value;
    });
    return paramObj;
  };

  return {
    searchParams: params,
    getParam,
    setParam,
    deleteParam,
    getAllParams,
  };
};

export default useCustomSearchParams;
